/* eslint-disable no-param-reassign */
function hideShow() {
  const toggleTrig = document.querySelectorAll('.expand-collapse-button');
  if (toggleTrig) {
    Array.prototype.forEach.call(
      toggleTrig,
      (el) => {
        const currentText = el.dataset.textOriginal;
        const newText = el.dataset.textToggle;
        el.addEventListener('click', () => {
          if (currentText === el.innerHTML) {
            el.innerHTML = newText;
            el.classList.add('show-toggle');
            if (el.classList.contains('hide-toggle')) {
              el.classList.remove('hide-toggle');
            }
          } else {
            el.innerHTML = currentText;
            el.classList.add('hide-toggle');
            if (el.classList.contains('show-toggle')) {
              el.classList.remove('show-toggle');
            }
          }
        });
      }
    );
  }
}

hideShow();
